<template>
  <div id="contenedor-main-estadisticas-contratos">
    <Estadisticas
    titulo="Estadisticas - Contratos"
    :datosMostrar="datosMostrar" />
  </div>
</template>

<script>
import Estadisticas from '@/components/administracion/contratos/estadisticas/Main.vue';

export default {
  name: 'MainEstadisticasContratos',
  components: {
    Estadisticas,
  },
  data() {
    return {
      datosMostrar: [
        'contatos',
        'conAnticipo',
        'conAnticipoPorSolicitar',
        'sinAnticipo',
        'conConvModificatorio',
        'sinCatalogo',
        'conCatalogo',
        'sinPrograma',
        'sinDeducciones',
        'sinExpediente',
        'conExpediente',
        'conExpedienteCompleto',
        'conExpedienteIncompleto',
        'terminados',
        'rescindidos',
        'terminacionAnticipada',
        'avanceProgramado',
        'avanceFisico',
        'avanceFinanciero',
      ],
    };
  },

};
</script>

<style>

</style>
